/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Stephan JAMBOU
 * @date        22/04/2022 10:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import LangSwitcherAction from '@scripts/actions/LangSwitcherAction'
import BookingModal from '@scripts/components/booking-modal'
import Header from '@scripts/components/header'

document.addEventListener('DOMContentLoaded', () => {
    new Header()
    new LangSwitcherAction()
    new BookingModal()

    if ($('.home').length > 0) {
        import('@scripts/components/home' /* webpackChunkName: "scripts/home" */).then(
            ({ default: Home }) => {
                new Home()
            },
        )
    }
})
